/**
 * Run a task once the browser is idle, or after `timeoutMs` at the latest.
 *
 * For work that must happen but need not happen before first paint —
 * analytics, error tracking — so it stops competing with the page's own
 * scripts for the main thread during load. Safari has no
 * `requestIdleCallback`; there the task waits for the load event and then a
 * turn of the event loop. Does nothing outside a browser (SSR).
 */
export const runWhenIdle = (task: () => void, timeoutMs = 3000): void => {
    if (typeof window === 'undefined') {
        return;
    }

    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => task(), { timeout: timeoutMs });

        return;
    }

    if (document.readyState === 'complete') {
        window.setTimeout(task, 0);

        return;
    }

    window.addEventListener('load', () => window.setTimeout(task, 0), { once: true });
};
